(function(){
  'use strict';
  if(window.__kdkWomenMulti2026)return;
  window.__kdkWomenMulti2026=true;
  var KEY='filter.p.t.category';
  var controller=null;
  var task=0;
  var desiredURL=null;
  var drawerFocus=null;
  function pagePanel(){return document.querySelector('[data-kdk-panel]');}
  function baseCodes(value){
    return String(value||'').split(/__|[|,]/).map(function(x){return x.trim();}).filter(Boolean);
  }
  function readCodes(params){
    return Array.from(new Set(params.getAll(KEY).flatMap(baseCodes)));
  }
  function previewURL(href){
    var target=new URL(href,window.location.href);
    var current=new URL(window.location.href);
    var preview=current.searchParams.get('preview_theme_id');
    if(preview&&target.origin===current.origin&&!target.searchParams.has('preview_theme_id')){
      target.searchParams.set('preview_theme_id',preview);
    }
    return target;
  }
  function matching(base){
    return window.location.pathname.replace(/\/$/,'')===base.replace(/\/$/,'');
  }
  function filterStatus(value){
    var el=document.querySelector('[data-kdk-filter-status]');
    if(el)el.textContent=value||'';
  }
  function categoryURL(button){
    var base=button.getAttribute('data-base');
    var last=desiredURL?new URL(desiredURL):new URL(window.location.href);
    var same=last.pathname.replace(/\/$/,'')===base.replace(/\/$/,'');
    var url=same?last:new URL(base,window.location.origin);
    if(!same){
      var original=new URL(window.location.href);
      var preview=original.searchParams.get('preview_theme_id');
      if(preview)url.searchParams.set('preview_theme_id',preview);
    }
    var active=readCodes(url.searchParams).filter(function(code){return code!=='aa-1'&&code!=='aa-8';});
    var group=baseCodes(button.getAttribute('data-codes'));
    var selected=group.every(function(code){return active.indexOf(code)!==-1;});
    if(selected){active=active.filter(function(code){return group.indexOf(code)===-1;});}
    else{active=Array.from(new Set(active.concat(group)));}
    url.searchParams.delete(KEY);
    if(active.length)url.searchParams.set(KEY,active.join('__'));
    url.searchParams.delete('page');
    url.hash='CollectionProductsParent';
    return url;
  }
  function removeCategory(group){
    var url=new URL(desiredURL||window.location.href);
    var codes=readCodes(url.searchParams);
    var removed=baseCodes(group);
    codes=codes.filter(function(code){return removed.indexOf(code)===-1;});
    url.searchParams.delete(KEY);
    if(codes.length)url.searchParams.set(KEY,codes.join('__'));
    url.searchParams.delete('page');
    url.hash='CollectionProductsParent';
    return url;
  }
  function clearAll(){
    var url=new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach(function(key){
      if(key.indexOf('filter.')===0||key==='page'||key==='kdk_size')url.searchParams.delete(key);
    });
    url.hash='CollectionProductsParent';
    return url;
  }
  function syncSelected(href){
    var shown=new URL(href||window.location.href);
    var codes=readCodes(shown.searchParams);
    var custom=[];
    document.querySelectorAll('[data-kdk-multi-choice]').forEach(function(button){
      var group=baseCodes(button.getAttribute('data-codes'));
      var on=shown.pathname.replace(/\/$/,'')===button.getAttribute('data-base').replace(/\/$/,'')&&group.length>0&&group.every(function(code){return codes.indexOf(code)!==-1;});
      button.setAttribute('aria-pressed',on?'true':'false');
      if(on)custom.push({name:button.getAttribute('data-name'),codes:group.join('|')});
    });
    var recognized=new Set(custom.flatMap(function(x){return baseCodes(x.codes);}));
    if(codes.some(function(c){return !recognized.has(c);}))custom.push({name:'Alt kategori',codes:codes.filter(function(c){return !recognized.has(c);}).join('|')});
    document.querySelectorAll('[data-kdk-selected]').forEach(function(bar){
      var holder=bar.querySelector('[data-kdk-custom-pills]');
      if(!holder)return;
      holder.replaceChildren();
      custom.forEach(function(selection){
        var button=document.createElement('button');
        button.type='button';
        button.className='kdk-f-pill kdk-f-pill-button';
        button.setAttribute('data-kdk-remove-group',selection.codes);
        button.setAttribute('aria-label',selection.name+' seçimini kaldır');
        var label=document.createElement('span');label.textContent=selection.name;
        var cross=document.createElement('b');cross.setAttribute('aria-hidden','true');cross.textContent='×';
        button.append(label,cross);
        holder.append(button);
      });
      var nativeActive=bar.querySelectorAll('a.kdk-f-pill').length;
      bar.hidden=custom.length===0&&nativeActive===0;
    });
    var badge=document.querySelector('[data-kdk-current-count]');
    if(badge)badge.hidden=custom.length===0;
  }
  function closeDrawer(){
    var panel=pagePanel();if(!panel)return;
    panel.classList.remove('is-open');
    document.body.classList.remove('kdk-f-drawer-lock');
    var overlay=document.querySelector('[data-kdk-panel-overlay]');
    if(overlay)overlay.hidden=true;
    var open=document.querySelector('[data-kdk-panel-open]');
    if(open)open.setAttribute('aria-expanded','false');
    if(drawerFocus&&window.innerWidth<=1024&&typeof drawerFocus.focus==='function')drawerFocus.focus();
  }
  function openDrawer(){
    var panel=pagePanel();if(!panel)return;
    drawerFocus=document.activeElement;
    panel.classList.add('is-open');
    document.body.classList.add('kdk-f-drawer-lock');
    var overlay=document.querySelector('[data-kdk-panel-overlay]');
    if(overlay)overlay.hidden=false;
    var open=document.querySelector('[data-kdk-panel-open]');
    if(open)open.setAttribute('aria-expanded','true');
    var close=panel.querySelector('[data-kdk-panel-close]');
    if(close)close.focus();
  }
  function themeRefresh(){
    ['collectionSwatch','loadMoreCollection','Onscrollproducts','getCountDownElments','quickviewElements','customDropdownElements','SidedrawerEventInit','productCardHoverInit'].forEach(function(name){
      try{if(typeof window[name]==='function')window[name]();}catch(e){}
    });
    try{if(window.AOS&&typeof window.AOS.refreshHard==='function')window.AOS.refreshHard();}catch(e){}
  }
  async function navigate(url,record){
    var current=new URL(window.location.href);
    var target=previewURL(url.href||url);
    desiredURL=target.toString();
    syncSelected(desiredURL);
    if(target.origin!==current.origin||target.pathname!==current.pathname){
      window.location.assign(target.toString());
      return;
    }
    var results=document.getElementById('CollectionProductsParent');
    var panel=pagePanel();
    if(!results||!panel||!results.dataset.id){
      window.location.assign(target.toString());return;
    }
    if(controller)controller.abort();
    controller=new AbortController();
    var ownTask=++task;
    results.setAttribute('aria-busy','true');
    panel.classList.add('is-loading');
    filterStatus('Ürünler güncelleniyor…');
    try{
      var ajax=new URL(target.toString());
      ajax.searchParams.set('section_id',results.dataset.id);
      ajax.hash='';
      var response=await fetch(ajax.toString(),{signal:controller.signal,credentials:'same-origin',headers:{'Accept':'text/html'}});
      if(!response.ok)throw new Error('Filter request failed: '+response.status);
      var html=await response.text();
      if(ownTask!==task)return;
      var doc=new DOMParser().parseFromString(html,'text/html');
      var incoming=doc.getElementById('CollectionProductsParent');
      var incomingPanel=doc.querySelector('[data-kdk-panel]');
      if(!incoming||!incomingPanel)throw new Error('Filter results not available');
      var oldNative=panel.querySelector('[data-kdk-native-facets]');
      var newNative=incomingPanel.querySelector('[data-kdk-native-facets]');
      var opened=new Set(Array.from(panel.querySelectorAll('.kdk-f-native-group[open]')).map(function(el){return el.getAttribute('data-kdk-native-group');}));
      if(oldNative&&newNative)oldNative.replaceWith(newNative);
      else if(oldNative&&!newNative)oldNative.remove();
      else if(!oldNative&&newNative){var sortWrap=panel.querySelector('.kdk-f-sort');if(sortWrap)sortWrap.before(newNative);}
      panel.querySelectorAll('.kdk-f-native-group').forEach(function(el){
        var key=el.getAttribute('data-kdk-native-group');if(opened.has(key))el.open=true;
      });
      var sidebarSelected=panel.querySelector('[data-kdk-selected]');
      var newSelected=incomingPanel.querySelector('[data-kdk-selected]');
      if(sidebarSelected&&newSelected)sidebarSelected.replaceWith(newSelected);
      var count=incoming.querySelector('.Product-result .total_products');
      var mobileCount=document.querySelector('[data-kdk-product-count]');
      if(count&&mobileCount)mobileCount.textContent=count.textContent.trim();
      results.replaceWith(incoming);
      if(record!==false)window.history.pushState({kdkWomenMulti:true},'',target.pathname+target.search+target.hash);
      desiredURL=null;
      syncSelected();
      themeRefresh();
      filterStatus('Ürünler güncellendi.');
    }catch(error){
      if(error&&error.name==='AbortError')return;
      if(ownTask===task){desiredURL=null;window.location.assign(target.toString());}
    }finally{
      if(ownTask===task){
        var latest=document.getElementById('CollectionProductsParent');
        if(latest)latest.removeAttribute('aria-busy');
        panel.classList.remove('is-loading');
      }
    }
  }
  function init(){
    var panel=pagePanel();
    if(!panel)return;
    document.body.classList.add('kdk-women-multi');
    syncSelected();
  }
  document.addEventListener('click',function(event){
    var open=event.target.closest('[data-kdk-panel-open]');
    if(open){event.preventDefault();openDrawer();return;}
    var close=event.target.closest('[data-kdk-panel-close],[data-kdk-panel-done],[data-kdk-panel-overlay]');
    if(close){event.preventDefault();closeDrawer();if(close.hasAttribute('data-kdk-panel-done'))document.getElementById('CollectionProductsParent')?.scrollIntoView({behavior:'smooth',block:'start'});return;}
    var choice=event.target.closest('[data-kdk-multi-choice]');
    if(choice){
      event.preventDefault();
      navigate(categoryURL(choice));
      return;
    }
    var remove=event.target.closest('[data-kdk-remove-group]');
    if(remove){event.preventDefault();navigate(removeCategory(remove.getAttribute('data-kdk-remove-group')));return;}
    var link=event.target.closest('a[href]');
    if(!link)return;
    if(!link.hasAttribute('data-kdk-filter-link')){
      var header=link.closest('#mobileMenu,.header-nav-blocks,.nav-menu-wrapper,header,.secondary-header');
      if(!header||link.href.indexOf('filter.p.t.category=')<0)return;
    }
    var target=previewURL(link.href);
    if(target.origin!==window.location.origin)return;
    if(link.hasAttribute('data-kdk-clear-all'))target=clearAll();
    else if(target.pathname===window.location.pathname){
      var dressSizes=new URL(window.location.href).searchParams.get('kdk_size');
      if(dressSizes&&!target.searchParams.has('kdk_size'))target.searchParams.set('kdk_size',dressSizes);
    }
    event.preventDefault();
    navigate(target);
  });
  document.addEventListener('input',function(event){
    var box=event.target.closest('[data-kdk-option-search]');
    if(!box)return;
    var list=box.closest('.kdk-f-native-group')?.querySelector('[data-kdk-native-values]');
    if(!list)return;
    var term=box.value.trim().toLocaleLowerCase('tr');
    list.querySelectorAll('[data-kdk-filter-item]').forEach(function(item){
      item.hidden=!item.getAttribute('data-name').includes(term);
    });
  });
  document.addEventListener('submit',function(event){
    var form=event.target.closest('[data-kdk-price-form]');
    if(!form)return;
    event.preventDefault();
    if(!form.reportValidity())return;
    var url=new URL(window.location.href);
    Array.from(new FormData(form).entries()).forEach(function(entry){
      var key=entry[0],value=String(entry[1]).trim();
      if(!key.startsWith('filter.v.price.'))return;
      url.searchParams.delete(key);
      if(value!==''&&Number(value)>=0)url.searchParams.set(key,value);
    });
    url.searchParams.delete('page');
    url.hash='CollectionProductsParent';
    navigate(url);
  });
  document.addEventListener('change',function(event){
    var sel=event.target.closest('[data-kdk-sort]');
    if(!sel)return;
    var url=new URL(window.location.href);
    url.searchParams.set('sort_by',sel.value);
    url.searchParams.delete('page');
    url.hash='CollectionProductsParent';
    navigate(url);
  });
  window.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&pagePanel()?.classList.contains('is-open'))closeDrawer();
  });
  window.addEventListener('resize',function(){
    if(window.innerWidth>1024&&pagePanel()?.classList.contains('is-open'))closeDrawer();
  },{passive:true});
  window.addEventListener('popstate',function(){if(pagePanel())navigate(new URL(window.location.href),false);});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();